module.exports = __webpack_public_path__ + "img/playImg.e3e92561.png";